import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {StyledFileContainer, StyledFileContent} from "./file.style";
import {ReportRowFile} from "../../reportPage.component";
import {StyledLightRedButton} from "@components/button/button.style";
import {IonAlert} from "@ionic/react";
import {ReactComponent as EditIcon} from "@assets/images/travelAllowance/edit.svg";
import {ReactComponent as ScanIcon} from "@assets/images/scan.svg";
import FilenameEditModal from "@app/reportPage/modals/filenameEditModal.component";
import SimpleScannerModal from "@app/reportPage/modals/simpleScannerModal.component";
import TruncateText from "@components/truncateText/truncateText.component";

type ReportFileProps = {
    onEdit: (file: ReportRowFile) => void;
    onRemove: (file: ReportRowFile) => void;
    file: ReportRowFile;
    reportPreview: boolean;
}

const ReportFile: React.FC<ReportFileProps> = (props: ReportFileProps) => {
    const {t} = useTranslation();

    const [showRemoveAlert, updateShowRemoveAlert] = useState<boolean>(false);
    const [isFilenameEditModalOpen, setIsFilenameEditModalOpen] = useState<boolean>(false);
    const [isFilenameScannerModalOpen, setIsFilenameScannerModalOpen] = useState<boolean>(false);

    const handleFilenameEditModalSubmit = (filename: string) => {
        editFilename(filename);
        setIsFilenameEditModalOpen(false);
    }

    const handleFilenameScanModalSubmit = (filename: string) => {
        editFilename(filename);
        setIsFilenameScannerModalOpen(false);
    }

    const editFilename = (filename: string) => {
        props.file.original_name = filename;
        props.onEdit(props.file);
    }

    return (
        <StyledFileContainer>
            <StyledFileContent>
                <div className="title-wrapper justify-content-center">
                    <div className="title"><TruncateText width={250}>{props.file.original_name}</TruncateText></div>
                    <EditIcon onClick={() => setIsFilenameEditModalOpen(true)}/>
                    <ScanIcon onClick={() => setIsFilenameScannerModalOpen(true)}/>
                </div>
                <hr/>
                <span className="preview">
                    {
                        !props.file?.offline_base64 && props.file?.original_name && props.file?.extension != 'pdf' &&
                        <img src={process.env.REACT_APP_API_ENDPOINT + 'file/uploads/' + props.file?.path}/>
                    }
                    {
                        props.file?.offline_base64 &&
                        <img src={'data:image/jpeg;base64, ' + props.file.offline_base64}/>
                    }
                </span>
                {
                    !props.reportPreview &&
                    <StyledLightRedButton
                        onClick={() => updateShowRemoveAlert(true)}
                        disabled={props.reportPreview}
                    >
                        {t("reportPage.files.remove")}
                    </StyledLightRedButton>}
            </StyledFileContent>
            <IonAlert
                isOpen={showRemoveAlert}
                onDidDismiss={() => updateShowRemoveAlert(false)}
                header={t('common.alertHeader')}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            updateShowRemoveAlert(false);
                        },
                    },
                    {
                        text: t('common.alertConfirm'),
                        handler: async () => {
                            props.onRemove(props.file)
                            updateShowRemoveAlert(false);
                        }
                    }
                ]}
            />
            <FilenameEditModal
                isOpen={isFilenameEditModalOpen}
                onClose={() => setIsFilenameEditModalOpen(false)}
                onSubmit={handleFilenameEditModalSubmit}
                file={props.file}
            />
            <SimpleScannerModal
                isOpen={isFilenameScannerModalOpen}
                onClose={() => setIsFilenameScannerModalOpen(false)}
                onSubmit={handleFilenameScanModalSubmit}
            />
        </StyledFileContainer>
    );
};

export default ReportFile;